export default __webpack_public_path__ + "static/media/cancer-page-1.f3e269ab.png";